import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Modal, UiCoreModule } from '@softline/ui-core';

@Component({
    selector: 'soft-change-pick-up-date-dialog',
    templateUrl: './change-pick-up-date-dialog.component.html',
    styleUrls: ['./change-pick-up-date-dialog.component.scss'],
    imports: [
        UiCoreModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChangePickUpDateDialogComponent implements Modal<{ abholdatum: string } | 'DISMISSED'> {

  currentDate: string | undefined;
  close!: (result: ({ abholdatum: string } | 'DISMISSED')) => void;

  constructor() { }

  registerCloseHandler(handler: (result: ({ abholdatum: string } | 'DISMISSED')) => void) {
    this.close = handler;
  }
}
